import React, { useState } from "react";
import { Tabs, Tab, Container } from "react-bootstrap";
import "./index.scss";
import ConfigFrTab from "../../component/configFrTab";
import ConfigUkTab from "../../component/configUkTab";
import ConfigLuxTab from "../../component/configLuxTab";
export const ConfigurationTab = () => {
  const [activeTab, setActiveTab] = useState("config1");

  return (
    <div className="simulation-tabs">
      <Tabs
        id="simulation-tabs"
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-3 custom-tabs"
        justify
      >
        <Tab eventKey="config1" title="Configuration Fr">
          <div className="tab-content">    <ConfigFrTab configId="686f7852aa2568ab72c11d4d" /></div>
        </Tab>
        <Tab eventKey="config2" title="Configuration Uk">
          <div className="tab-content"><ConfigUkTab configId="686f8985db554e6ca24ddfef" /></div>
        </Tab>
        <Tab eventKey="config3" title="Configuration LUX">
          <div className="tab-content"><ConfigLuxTab configId="686fa90b9f3199bea05e976d" /></div>
        </Tab>
      </Tabs>
    </div>
  );
}
